import React from "react"

export default {
    SwiftFederation: React.lazy(() => import("./External.SwiftFederation")),
    SwiftCoder: React.lazy(() => import("./External.SwiftCoder")),
    Mlytics: React.lazy(() => import("./External.Mlytics")),
    AliyunCDN: React.lazy(() => import("./External.Aliyun.CDN")),
    ConversantCDN: React.lazy(() => import("./External.Conversant.CDN")),
    ConversantLive: React.lazy(() => import("./External.Conversant.Live"))
}